import quantityId from '../enums/quantityId.js';
import Quantity from '../entities/quantity.js';
import Unit from '../entities/unit.js';

const mass = new Quantity(
    quantityId.MASS,
    'Mass'
);

mass.registerUnit(
    new Unit(
        'kg', 1, 'kilogram', [
            "kg"
        ]
    )
);

mass.registerUnit(
    new Unit(
        'g', 1000, 'grams', [
            "g"
        ]
    )
);

mass.registerUnit(
    new Unit(
        'oz', 35.273953395347, 'ounce', [
            "oz"
        ]
    )
);

mass.registerUnit(
    new Unit(
        'lb', 2.2046203472022, 'pound UK', [
            "lb"
        ]
    )
);

export default mass;